import React from 'react';
import { Col, FormGroup } from 'reactstrap';
import { Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';

import HourMaskCenter from '../../../../components/Inputs/HourMaskCenter';
import { hourRules } from '../../utils';

const DaySchedule = ({
  day,
  showDisabled,
  setShowDisabled,
  control,
  errors,
  errorFormMessage,
  setValue,
  portugueseName
}) => {
  const beginTimeFieldName = `begin_time_${day}`;
  const endTimeFieldName = `end_time_${day}`;

  return (
    <Col className="col-sm">
      <FormGroup>
        <h5>
          <input
            type="checkbox"
            checked={showDisabled}
            className="checkbox-round"
            onChange={() => setShowDisabled(!showDisabled)}
            style={{ marginRight: '0.5rem' }}
          />
          {portugueseName}
        </h5>
        <Controller
          render={(props) => (
            <HourMaskCenter
              valueController={setValue}
              fieldName={beginTimeFieldName}
              value={props.value}
              placeholder=""
            />
          )}
          control={control}
          name={beginTimeFieldName}
          rules={hourRules}
          defaultValue="08:00"
        />
        <ErrorMessage
          errors={errors}
          name={beginTimeFieldName}
          render={({ message }) => errorFormMessage(message)}
        />
      </FormGroup>
      <FormGroup>
        <Controller
          render={(props) => (
            <HourMaskCenter
              valueController={setValue}
              fieldName={endTimeFieldName}
              value={props.value}
              placeholder=""
            />
          )}
          control={control}
          name={endTimeFieldName}
          rules={hourRules}
          defaultValue="23:00"
        />
        <ErrorMessage
          errors={errors}
          name={endTimeFieldName}
          render={({ message }) => errorFormMessage(message)}
        />
      </FormGroup>
    </Col>
  );
};

export default DaySchedule;
